import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/pay-monthly-deductions', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/pay-monthly-deductions', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const importLeave = data => {
  return httpClient
    .post('/api/pay-monthly-deductions/import-leave-records', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, options = {}) => {
  return httpClient
    .get(`/api/pay-monthly-deductions/${id}`, options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/pay-monthly-deductions/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/pay-monthly-deductions/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getItemDeduction = (Option = {}) => {
  return httpClient
    .get(
      '/api/pay-item-deductions?page=-1&include=item_custom_rule&fields[pay_item_deduction]=deduction_id,deduction_item,custom_keyword&filter[item_type]=5&fields[item_custom_rule]=keyword,custom_rule,item_type_id'
    )
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getLeaveRecord = (options = {}) => {
  return httpClient
    .get(`/api/leave-records?filter[leave_type_id]=${options.leave_type_id}`, options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, find, update, destroy, getItemDeduction, getLeaveRecord, importLeave }
